import { handleActions } from 'redux-actions';
import {
  AccountActionsEnum,
  LoginAccountByEmail,
  LoginAccountByFacebook,
  LoginAccountByGoogle,
  LoginAccountError,
  LoginAccountSuccess,
  LoginSelectAccount,
  PromptUnusualActivity,
  RegisterAccountByEmail,
  RegisterAccountByFacebook,
  RegisterAccountByGoogle,
  RegisterAccountError,
  RegisterAccountSuccess,
  SetReturnUrl,
  SetTrackingObject,
} from '../actions';
import { GrantTypeEnum, IAccountResponseError } from '../../account.data';
import { Account, UserAccount } from '../models';
import { ROUTER_REQUEST } from '@ngrx/router-store';

export interface IState {
  account: Account;
  error: Error | IAccountResponseError;
  registered: boolean;
  registering: boolean;
  registrationType: GrantTypeEnum;
  returnUrl: string;
  userAccount: UserAccount;
  loggingIn: boolean;
  loggedIn: boolean;
  userEmail: string;
  trackingObject: any;
}

export const initialState: IState = {
  account: null,
  error: null,
  registering: false,
  registered: false,
  registrationType: null,
  returnUrl: null,
  userAccount: null,
  loggingIn: false,
  loggedIn: false,
  userEmail: null,
  trackingObject: null,
};

const reducerFn = handleActions(
  {
    // clear the error when user navigates to a different route
    [ROUTER_REQUEST]: function (state: IState) {
      return {
        ...state,
        error: null,
      };
    },
    [AccountActionsEnum.REGISTER_ACCOUNT_EMAIL]: function (
      state: IState,
      { payload }: RegisterAccountByEmail
    ) {
      return {
        ...state,
        registering: true,
        registered: false,
        registrationType: GrantTypeEnum.password,
        userEmail: payload.email,
        error: null,
      };
    },
    [AccountActionsEnum.REGISTER_ACCOUNT_GOOGLE]: function (
      state: IState,
      { payload }: RegisterAccountByGoogle
    ) {
      return {
        ...state,
        registering: true,
        registered: false,
        registrationType: GrantTypeEnum.google,
        userEmail: payload.email,
        error: null,
      };
    },
    [AccountActionsEnum.REGISTER_ACCOUNT_FACEBOOK]: function (
      state: IState,
      { payload }: RegisterAccountByFacebook
    ) {
      return {
        ...state,
        registering: true,
        registered: false,
        registrationType: GrantTypeEnum.facebook,
        userEmail: payload.email,
        error: null,
      };
    },
    [AccountActionsEnum.REGISTER_ACCOUNT_SUCCESS]: function (
      state: IState,
      { payload }: RegisterAccountSuccess
    ) {
      return {
        ...state,
        registered: true,
        account: payload.account,
        error: null,
      };
    },
    [AccountActionsEnum.REGISTER_ACCOUNT_ERROR]: function (
      state: IState,
      { payload }: RegisterAccountError
    ) {
      return {
        ...state,
        registering: false,
        registered: false,
        account: null,
        userEmail: null,
        error: payload.error,
      };
    },
    [AccountActionsEnum.SET_RETURN_URL]: function (
      state: IState,
      { payload }: SetReturnUrl
    ) {
      return {
        ...state,
        returnUrl: payload.returnUrl,
      };
    },
    [AccountActionsEnum.LOGIN_ACCOUNT_EMAIL]: function (
      state: IState,
      { payload }: LoginAccountByEmail
    ) {
      return {
        ...state,
        userAccount: null,
        loggingIn: true,
        loggedIn: false,
        userEmail: payload.email,
        error: null,
      };
    },
    [AccountActionsEnum.LOGIN_ACCOUNT_FACEBOOK]: function (
      state: IState,
      { payload }: LoginAccountByFacebook
    ) {
      return {
        ...state,
        userAccount: null,
        loggingIn: true,
        loggedIn: false,
        userEmail: payload.email,
        error: null,
      };
    },
    [AccountActionsEnum.LOGIN_ACCOUNT_GOOGLE]: function (
      state: IState,
      { payload }: LoginAccountByGoogle
    ) {
      return {
        ...state,
        userAccount: null,
        loggingIn: true,
        loggedIn: false,
        userEmail: payload.email,
        error: null,
      };
    },
    [AccountActionsEnum.LOGIN_ACCOUNT_COMPANY]: function (state: IState) {
      return {
        ...state,
        loggingIn: true,
        loggedIn: false,
        error: null,
      };
    },
    [AccountActionsEnum.LOGIN_ACCOUNT_SUCCESS]: function (
      state: IState,
      { payload }: LoginAccountSuccess
    ) {
      return {
        ...state,
        loggedIn: true,
        userAccount: payload.userAccount,
        error: null,
      };
    },
    [AccountActionsEnum.LOGIN_ACCOUNT_ERROR]: function (
      state: IState,
      { payload }: LoginAccountError
    ) {
      return {
        ...state,
        userAccount: null,
        loggingIn: false,
        loggedIn: false,
        userEmail: null,
        error: payload.error,
      };
    },
    [AccountActionsEnum.LOGIN_SELECT_ACCOUNT]: function (
      state: IState,
      { payload }: LoginSelectAccount
    ) {
      return {
        ...state,
        loggingIn: false,
        loggedIn: false,
        userAccount: payload.userAccount,
        error: null,
      };
    },
    [AccountActionsEnum.PROMPT_UNUSUAL_ACTIVITY]: function (
      state: IState,
      { payload }: PromptUnusualActivity
    ) {
      return {
        ...state,
        loggingIn: false,
        loggedIn: false,
        error: null,
      };
    },
    [AccountActionsEnum.SET_TRACKING_OBJECT]: function (
      state: IState,
      { payload }: SetTrackingObject
    ) {
      return {
        ...state,
        trackingObject: payload.trackingObject,
      };
    },
  } as any,
  initialState
);

export function reducer(state: IState, action: any) {
  return reducerFn(state, action);
}
